import React from 'react'
import Banner from 'components/Banner'
import { Pill, MaterialIcon } from '@dsny/dsny-component-library'
import {
  HighlightedText,
  BannerText,
  CloseButton
} from '../Banner/Banner.styles'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { REQUEST_MORE_MUSIC_URL } from 'utils/constants'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'

export default function UserVerificationBanner({ onClose = () => {} }) {
  const theme = useTheme()
  const { t } = useTranslation()
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2

  return (
    <Banner>
      <HighlightedText $responsiveBreakpointsV2={responsiveBreakpointsV2}>
        <MaterialIcon
          name="MusicNoteOutlined"
          color={theme.colors.neutralC20}
          style={{ marginRight: 8, display: 'inline-flex' }}
        />
        {t('verification.banner-title')}
      </HighlightedText>
      <BannerText $responsiveBreakpointsV2={responsiveBreakpointsV2}>
        {t('verification.banner-text')}
      </BannerText>

      <div className="actions">
        <Pill
          variant="tonal"
          mode="dark"
          label={t('settings.request-new-content')}
          style={{
            marginLeft: 20,
            width: 131,
            backgroundColor: theme.colors.neutralW30,
            color: theme.colors.neutralW90
          }}
          onClick={() => window.open(REQUEST_MORE_MUSIC_URL, '_blank')}
        />
        <CloseButton onClick={onClose}>
          <MaterialIcon
            name="X"
            style={{
              color: theme.colors.neutralW40
            }}
          />
        </CloseButton>
      </div>
    </Banner>
  )
}
